/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const HasHires = {
    True: 'True',
    False: 'False',
    Ongoing: 'Ongoing'
};
export function instanceOfHasHires(value) {
    for (const key in HasHires) {
        if (Object.prototype.hasOwnProperty.call(HasHires, key)) {
            if (HasHires[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function HasHiresFromJSON(json) {
    return HasHiresFromJSONTyped(json, false);
}
export function HasHiresFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function HasHiresToJSON(value) {
    return value;
}
export function HasHiresToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
